import {elys} from '@elys-network/elys-telescope';
import {useSuspenseQuery} from '@tanstack/react-query';

import {ELYS_CHAIN} from 'app/chains/chains.constants';
import {CosmosChainId} from 'app/chains/cosmos/cosmos.types';
import {useChain} from '../useChain';

export const useElysClient = (chainId: CosmosChainId = ELYS_CHAIN.chainId) => {
  const chain = useChain(chainId);

  return useSuspenseQuery({
    queryKey: ['elysClient', chainId],
    queryFn: async () => {
      const client = await elys.ClientFactory.createRPCQueryClient({
        rpcEndpoint: chain.rpcURL,
      });

      return client;
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
